@use "~theme/typography";

.container {
  text-align: center;
  z-index: var(--session-timeout);
}

.buttonRow {
  display: flex;
  flex-direction: row;
}

.button {
  &:first-child {
    margin-right: 10px;
  }

  &:last-child {
    margin-left: 10px;
  }
}

.header {
  @include typography.body-semibold;
  margin: 0;
}

.body {
  @include typography.body;
  margin: 28px 0;
}
